module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      "modal": true, "show": _vm.show, "hidden": !_vm.show
    },
    attrs: {
      "id": "myModal"
    }
  }, [_c('div', {
    class: {
      "modal-content": true, "fixed-width-modal": !_vm.config.buttons.decline.present
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.config.header))]), _vm._v(" "), _c('main', [(_vm.config.type !== null) ? _c('div', [(_vm.config.type === "ERROR") ? _c('error') : _vm._e(), _vm._v(" "), (_vm.config.type === "SUCCESS") ? _c('success') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body fix-height"
  }, [(_vm.messageIsArray) ? _c('ul', _vm._l((_vm.config.message), function(message) {
    return _c('li', [_vm._v(" " + _vm._s(message) + " ")])
  })) : _c('p', [_vm._v(_vm._s(_vm.config.message))])])]), _vm._v(" "), _c('footer', [(!_vm.config.buttons.decline.present) ? _c('single-button', {
    attrs: {
      "buttonText": _vm.config.buttons.accept.text,
      "error": _vm.error,
      "action": _vm.config.buttons.accept.action
    },
    model: {
      value: (_vm.result),
      callback: function($$v) {
        _vm.result = $$v
      }
    }
  }) : _c('dual-buttons', {
    attrs: {
      "buttonText": _vm.config.buttons,
      "action": _vm.config.buttons.accept.action
    },
    model: {
      value: (_vm.result),
      callback: function($$v) {
        _vm.result = $$v
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49c67979!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/modal/Modal.vue
// module id = 365
// module chunks = 2